import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import { getDiagnosis, getProcedure, getModifier } from "apiHandler/actions";
import useDebounce from "components/customHooks/useDebounce";
import { useUserData } from "components/customHooks/userDataContext";

const AddCodesDialog = ({ open, type, onClose, onAdd }) => {
  const [input, setInput] = useState("");
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const userData = useUserData();
  const token = userData?.access_token;

  const search = async () => {
    if (!input) return;
    setLoading(true);

    let res;
    if (type === "Diagnosis")
      res = await getDiagnosis({ type: type, search_by: input }, token);
    if (type === "Procedure")
      res = await getProcedure({ type: type, search_by: input }, token);
    if (type === "Modifier")
      res = await getModifier(
        { type: type, search_by: input },
        userData.billing_access_token,
      );

    setOptions(res || []);
    setLoading(false);
  };

  useDebounce(search, 700, [input]);

  return (
    <Dialog open={open} fullWidth maxWidth="md">
      <DialogTitle>Add {type} Codes</DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          options={options}
          getOptionLabel={(o) => `${o.code} - ${o.description}`}
          onInputChange={(e, v) => setInput(v)}
          onChange={(e, v) => setSelected(v)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search code or description"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => {
            onAdd(selected);
            onClose();
          }}
        >
          Add Selected
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCodesDialog;
